import './App.css';
import React, { useState,useEffect } from 'react';
import PageHeader from './PageHeader';
import PageFooter from './PageFooter';
import PageMobileView from './PageMobileView';


function App() {
  const [screenSize, setScreenSize] = useState(getCurrentDimension());
  function getCurrentDimension(){
    return {
        width: window.innerWidth,
        height: window.innerHeight
    }
  }
  useEffect(() => {
    const updateDimension = () => {
        setScreenSize(getCurrentDimension())
    }
    window.addEventListener('resize', updateDimension);


    return(() => {
        window.removeEventListener('resize', updateDimension);
    })
}, [screenSize])

  if(screenSize.width > 800){
    return (
      <div className="App" >
        <div className="page-header">
          <PageHeader />
        </div>
      
        <div className="page-footer"><PageFooter classDescription={"footer-info"}/></div>
      </div>
    );

  }else{
    return (
      <div className="App" >
        <div>
          <PageMobileView />
        </div>
      
        <div className="page-footer-mobile">
          <PageFooter classDescription={"footer-info-mobile"}/>
        </div>
      </div>
    );
  }
}

export default App;
